import React from 'react'
import { Stack } from '@chakra-ui/react'

const BackToTopSwitch = () => {
  return (
    <Stack>
      <div id="elevator_item">
        <button id="elevator" onClick={() => {return false}} title="Back To Top" > </button>
      </div>
    </Stack>
  )
}

export default BackToTopSwitch